import { create } from 'zustand';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import { DEFAULT_ADMIN_PROFILE_ID, DEFAULT_EMPTY_ID_STATE } from 'utils/isMarketStateSet';
import { MarketInput, MarketMetric, GroupOption, ShippingMethod, RefetchType } from 'generated/graphql';

const useMarketStateStore = create<{
  input: MarketInput;
  setInput: (newInput: Partial<MarketInput>) => void;
  // True once the user has explicitly applied a fulfilment choice (truck or no truck).
  // Shared across all useShippingMethod instances so none of them auto-applies the
  // buyer's default truck over an explicit choice. Reset when the buyer changes.
  userSetTruck: boolean;
  setUserSetTruck: (userSetTruck: boolean) => void;
}>((set) => ({
  input: {
    buyerID: DEFAULT_EMPTY_ID_STATE,
    filters: [],
    groupOption: GroupOption.Seller,
    method: ShippingMethod.Hub,
    metric: MarketMetric.Pallets,
    paginationOption: { pageNumber: 1, pageSize: DEFAULT_PAGE_SIZE, ids: [], type: RefetchType.Unknown },
    search: '',
    truckTypeUUID: DEFAULT_ADMIN_PROFILE_ID,
  },
  setInput: (newInput: Partial<MarketInput>) =>
    set((store) => ({
      input: {
        ...store.input,
        ...newInput,
      },
    })),
  userSetTruck: false,
  setUserSetTruck: (userSetTruck: boolean) => set({ userSetTruck }),
}));

export default useMarketStateStore;
